import { useEffect, useRef } from 'react';
import dayjs from 'dayjs';

import { formatCPF } from '@wareclouds/frontend-common';
import { formatRut } from '@wareclouds/frontend-common/b2c';

import { LEAD_EVENT_STAGES } from '../../constants/leadEventStages';
import { mapVehicleTypeToApi } from '../mappers';
import { IS_BR, VEHICLE_TYPES } from '../utils/registrationConfig';

function findLastLeadEventByStage(events, stage) {
  if (!Array.isArray(events)) return null;
  for (let i = events.length - 1; i >= 0; i -= 1) {
    if (events[i]?.stage === stage) return events[i];
  }
  return null;
}

export function useRegistrationPrefill({ leadEvents, setValue }) {
  const prefillsAppliedRef = useRef(false);

  useEffect(() => {
    if (prefillsAppliedRef.current) return;
    if (!leadEvents.length) return;

    const personalDetailsEvent = findLastLeadEventByStage(
      leadEvents,
      LEAD_EVENT_STAGES.PERSONAL_DETAILS
    );
    const vehicleInfoEvent = findLastLeadEventByStage(
      leadEvents,
      LEAD_EVENT_STAGES.VEHICLE_INFO
    );

    if (personalDetailsEvent?.content) {
      const content = personalDetailsEvent.content;
      if (content.birth_date) {
        const parsedBirthDate = dayjs(content.birth_date);
        if (parsedBirthDate.isValid()) {
          setValue('birth_date', parsedBirthDate, {
            shouldDirty: false,
            shouldValidate: false,
          });
        }
      }

      if (IS_BR) {
        setValue('cpf', formatCPF(content.identity_number ?? ''), {
          shouldDirty: false,
          shouldValidate: false,
        });
        setValue('neighborhood', content.address_detail ?? '', {
          shouldDirty: false,
          shouldValidate: false,
        });
      } else {
        setValue('rut', formatRut(content.identity_number ?? ''), {
          shouldDirty: false,
          shouldValidate: false,
        });
      }

      setValue('address', content.address ?? '', {
        shouldDirty: false,
        shouldValidate: false,
      });
    }

    if (vehicleInfoEvent?.content?.vehicle_type) {
      const uiVehicleType = VEHICLE_TYPES.find(
        (vehicleType) =>
          mapVehicleTypeToApi(vehicleType) ===
          vehicleInfoEvent.content.vehicle_type
      );

      if (uiVehicleType) {
        setValue('vehicle_type', uiVehicleType, {
          shouldDirty: false,
          shouldValidate: false,
        });
      }
    }

    prefillsAppliedRef.current = true;
  }, [leadEvents, setValue]);
}
